import "../home/portfolio/Portfolio.css";
import { Container, Col, Row } from "react-bootstrap";
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
//
import PortfolioBigBox from "../../ui/boxes/PortfolioBigBox";
//
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import LearnMoreButtonClick from "../../ui/buttons/LearnButtonClick";
import { Skeleton } from "@mui/material";

const PortfolioForm = (props) => {
  const url = useSelector((state) => state.api.url);
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });

  const [selectedCategory, setSelectedCategory] = useState(0);
  const [projects, setProjects] = useState([]);
  const [offset, setOffset] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [showLoader, setShowLoader] = useState();
  const [showButton, setShowButton] = useState(true);
  const [viewMode, setViewMode] = useState("grid"); // "grid" or "list"

  const categoryHandler = (id) => {
    setOffset(0);
    setSelectedCategory(id);
  };

  const fetchProjects = useCallback(async () => {
    setIsLoading(true);
    try {
      await axios
        .get(
          `${url}/get-more-projects?offset=${offset}&limit=6&category_id=${selectedCategory}`
        )
        .then((res) => {
          if (res.data) {
            const newProjects = JSON.parse(res.data).projects;
            if (offset === 0) {
              setProjects(newProjects);
            } else {
              setProjects((prevProjects) => [...prevProjects, ...newProjects]);
            }
            if (newProjects.length < 6) {
              setShowButton(false);
            } else {
              setShowButton(true);
            }
          } else {
            console.log("no data");
          }
        });
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
    setIsLoading(false);
  }, [url, offset, selectedCategory]);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  const loadMoreHandler = (e) => {
    e.preventDefault();
    setOffset((o) => o + 6);
  };

  useEffect(() => {
    if (selectedCategory) {
      setShowLoader(true);
      setTimeout(() => {
        setShowLoader(false);
      }, 500);
    }
  }, [selectedCategory]);

  useEffect(() => {
    document
      .querySelector('meta[property="og:description"]')
      .setAttribute("content", "test description");
    document
      .querySelector('meta[property="og:image"]')
      .setAttribute(
        "content",
        "https://chat.openai.com/images/chatgpt-share-og.png"
      );
  }, []);

  return (
    <Container className="!pb-10 xs:!mt-14 !mt-32 relative" fluid>
      <Col className="!px-8 xs:!px-0 sm:!px-0">
        {/* Header Section */}
        <Row className="!flex !items-center !justify-center !flex-col !mb-5">
          <Col>
            {/* Badge */}
            <div className="inline-block px-4 py-2 bg-[#FDCF00]/10 rounded-full mb-6">
              <span className="text-[#FDCF00] font-medium text-sm tracking-wider uppercase">
                Our Projects
              </span>
            </div>
            
            {/* Main Headline */}
            <h2 className="text-4xl lg:text-6xl font-light text-white leading-tight mb-6 text-center">
              <span className="text-[#FDCF00]">Digital Experience</span> Matters
            </h2>
            
            {/* Description */}
            <p className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed text-center">
              We build DIGITAL products driven by strategy, design and technology.
            </p>
          </Col>
        </Row>
        {/* <Row className="xs:!px-0 !px-0 sm:!px-0 lg:!px-44 xl:!px-44 xxl:!px-44 xs:!pt-0 !pt-10">
          <Swiper
            slidesPerView={3}
            navigation={window.screen.width > 600 ? true : false}
            modules={[Navigation]}
            breakpoints={{
              460: {
                slidesPerView: 3,
                spaceBetween: 30,
                navigation: false,
              },
              640: {
                slidesPerView: 4,
                spaceBetween: 10,
                navigation: false,
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 70,
              },
              1200: {
                slidesPerView: 4,
                spaceBetween: 100,
              },
              1400: {
                slidesPerView: 5,
                spaceBetween: 0,
              },
            }}
            className="!m-auto !flex !text-center !justify-center !items-center"
          >
            <SwiperSlide
              tag="p"
              className={`pt-3 ${
                selectedCategory === 0 ? "!text-[#FDCF00]" : "!text-white"
              } xl:!whitespace-nowrap xxl:!whitespace-nowrap xs:text-[13px] xs:!w-max xs:!p-3 xs:!text-left sm:!text-[14px] text-[20px]
              hover:!text-[#FDCF00] !cursor-pointer`}
              onClick={() => categoryHandler(0)}
            >
              <span className="pof">All</span>{" "}
            </SwiperSlide>
            {props.content1?.map((p, i) => (
              <SwiperSlide
                key={i}
                tag="p"
                className={`pt-3 ${
                  selectedCategory === p.id ? "!text-[#FDCF00]" : "!text-white"
                } xl:!whitespace-nowrap xxl:!whitespace-nowrap xs:text-[13px] xs:!w-max xs:!p-3 xs:!text-left sm:!text-[14px] text-[20px]
                hover:!text-[#FDCF00] !cursor-pointer`}
                onClick={() => categoryHandler(p.id)}
              >
                <span className="pof">{p.category_name}</span>
              </SwiperSlide>
            ))}
          </Swiper>
        </Row> */}

        {/* Filters and View toggles */}
        <Row className="xs:!px-0 !px-0 sm:!px-0 lg:!px-44 xl:!px-44 xxl:!px-44 xs:!pt-0 !pt-10">
          <div className="flex items-center justify-between w-full gap-4">
            {/* Swipeable Filters */}
            <div className="flex-1 overflow-hidden">
              <Swiper
                slidesPerView="auto"
                spaceBetween={10}
                modules={[Navigation]}
                className="!w-full mySwiper"
                grabCursor={true}
              >
                <SwiperSlide className="!w-auto">
                  <button
                    onClick={() => categoryHandler(0)}
                    className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap ${
                      selectedCategory === 0
                        ? "bg-[#FDCF00] text-black shadow-sm font-medium"
                        : "text-gray-400 hover:text-white hover:bg-white/10"
                    }`}
                  >
                    All
                  </button>
                </SwiperSlide>
                {props.content1?.map((p, i) => (
                  <SwiperSlide key={i} className="!w-auto">
                    <button
                      onClick={() => categoryHandler(p.id)}
                      className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap ${
                        selectedCategory === p.id
                          ? "bg-[#FDCF00] text-black shadow-sm font-medium"
                          : "text-gray-400 hover:text-white hover:bg-white/10"
                      }`}
                    >
                      {p.category_name}
                    </button>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            {/* View toggles on the right - hidden on mobile */}
            {!isMobile && (
              <div className="flex items-center gap-2 flex-shrink-0">
                <button
                  onClick={() => setViewMode("grid")}
                  className={`w-9 h-9 flex items-center justify-center rounded-md transition-all duration-200 ${
                    viewMode === "grid"
                      ? "bg-[#FDCF00] text-black"
                      : "bg-white/10 hover:bg-[#FDCF00] hover:text-black text-white"
                  }`}
                  title="Grid View"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                  </svg>
                </button>
                <button
                  onClick={() => setViewMode("list")}
                  className={`w-9 h-9 flex items-center justify-center rounded-md transition-all duration-200 ${
                    viewMode === "list"
                      ? "bg-[#FDCF00] text-black"
                      : "bg-white/10 hover:bg-[#FDCF00] hover:text-black text-white"
                  }`}
                  title="List View"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
            )}
          </div>
        </Row>

        {/* Projects Grid */}
        <Row className="!m-auto !max-w-[1400px] !mt-5 relative">
          {!showLoader && projects?.length > 0 && (
            <div className={`!mx-auto !grid xs:!grid-cols-1 sm:!grid-cols-1 ${
              viewMode === "grid" ? "!grid-cols-2" : "!grid-cols-1"
            } !gap-8 xl:!gap-10 xxl:!gap-12 !place-items-start`}>
              {projects.map((p, i) => {
                const categoryIds = p.project_categories?.split(", ");
                const catName = categoryIds
                  ?.map((categoryId) => {
                    const category = props.content1?.find(
                      (cat) => cat.id === parseInt(categoryId)
                    );
                    return category ? category.category_name : "";
                  })
                  .join(", ");

                return (
                  <Link to={`/portfolio/${p.slug}`} key={i}>
                    <PortfolioBigBox
                      title={p.title}
                      image={p.main_image}
                      slug={p.slug}
                      catName={catName}
                      viewMode={viewMode}
                      className={i >= 6 ? "fade-in" : ""}
                    />
                  </Link>
                );
              })}
            </div>
          )}
          {(showLoader || isLoading) && (
            <div className="!mt-5 !flex xs:!flex-col !items-center !justify-between xs:!h-[300px] !h-[450px]">
              <Skeleton
                variant="rectangular"
                animation="wave"
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.63)",
                  borderRadius: "20px",
                  margin: "auto",
                }}
                className="xs:!w-[210px] !m-auto sm:!w-[200px] md:!w-[350px] !w-[40%] xs:!h-[300px] sm:!h-[300px] !h-[450px]"
              />
              <Skeleton
                variant="rectangular"
                animation="wave"
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.63)",
                  borderRadius: "20px",
                }}
                className="xs:!mt-5 xs:!w-[210px] !m-auto sm:!w-[200px] md:!w-[350px] !w-[40%] xs:!h-[300px] sm:!h-[300px] !h-[450px]"
              />
            </div>
          )}
          {!isLoading && projects?.length === 0 && (
            <h1 className="!text-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              No projects found
            </h1>
          )}
        </Row>

        {/* Load More Button */}
        {projects?.length >= 6 && showButton && (
          <LearnMoreButtonClick
            className="!m-auto !mt-10"
            onClick={loadMoreHandler}
          >
            Load More
          </LearnMoreButtonClick>
        )}
      </Col>
    </Container>
  );
};

export default PortfolioForm;
